<template>
  <div class="py-5 px-2">
    <div class="row d-flex justify-content-end">
      <div class="col-2 offset-9">
        <h3 class="blue-text b1">{{ $t("signIn") }}</h3>
      </div>
    </div>
    <v-form ref="form" v-model="valid">
      <v-text-field
        class="py-3"
        v-model="form.phoneNumber"
        pattern="[0-9]+"
        :rules="phoneNumberRule"
        label="شماره موبایل"
        prepend-icon="mdi-phone-outline"
        required
        placeholder="مثلا 0912123456"
      ></v-text-field>
      <v-text-field
        class="py-3"
        v-model="form.password"
        :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
        :rules="passwordRules"
        :type="show ? 'text' : 'password'"
        label="رمز عبور"
        prepend-icon="mdi-lock"
        @click:append="show = !show"
      ></v-text-field>

      <div class="row pt-5">
        <div class="col-5">
          <v-btn
            :disabled="!valid"
            class="blue-bcg fffcolor w-100"
            @click="validate"
          >
            {{ $t("signIn") }}
          </v-btn>
        </div>
        <div class="col-7">
          <!-- <v-btn outlined class="brown-text w-100" @click="google">
            {{ $t("google") }}<v-icon>mdi-google</v-icon>
          </v-btn> -->
        </div>
      </div>
    </v-form>
  </div>
</template>

<script>
import router from "../../router";
export default {
  data: () => ({
    show: false,
    valid: true,
    form: {
      password: "",
      phoneNumber: "",
      replacedPhoneNumber: "",
    },
    passwordRules: [
      (v) => !!v || "وارد کردن رمز عبور الزامی است",
      (v) => v.length >= 6 || "کلمه عبور کوتاه است",
    ],
    phoneNumberRule: [
      (v) => !!v || "وارد کردن شماره موبایل الزامی است",
      (v) => v.length == 11 || "شماره موبایل صحیح نیست",
    ],
  }),

  methods: {
    validate() {
      this.$refs.form.validate();
      if (this.valid == false) return;
      else {
        var persianNumbers = [
            /۰/g,
            /۱/g,
            /۲/g,
            /۳/g,
            /۴/g,
            /۵/g,
            /۶/g,
            /۷/g,
            /۸/g,
            /۹/g,
          ],
          arabicNumbers = [
            /٠/g,
            /١/g,
            /٢/g,
            /٣/g,
            /٤/g,
            /٥/g,
            /٦/g,
            /٧/g,
            /٨/g,
            /٩/g,
          ],
          fixNumbers = function (str) {
            if (typeof str === "string") {
              for (var i = 0; i < 10; i++) {
                str = str
                  .replace(persianNumbers[i], i)
                  .replace(arabicNumbers[i], i);
              }
            }
            return str;
          };
        this.form.replacedPhoneNumber = fixNumbers(this.form.phoneNumber);
        var signinForm = {
          username: this.form.replacedPhoneNumber,
          password: this.form.password,
        };
        this.axios
          .post("token/", signinForm)
          .then((response) => {
            console.log(response.data.access);
            this.axios.defaults.headers.common["Authorization"] =
              "Bearer " + this.$session.set("token", response.data.access);
            this.$session.set("login", true);
            this.$noty.success(this.$t("loginSuccess"));
            router.push("/");
          })
          .catch((error) => {
            console.log(error);
            this.$noty.error(this.$t("signErrorNoty"));
          });
      }
    },
    google() {
      this.axios.get("accounts/google/login");
      this.$session.set("login", true);
    },
  },
};
</script>
